<template lang="pug">
  .pho-checkbox.mb-3
    v-checkbox(
      v-model="lazyValue"
      :color="color"
      :disabled="disabled"
      :data-test-id="dataTestId"
      @change="$emit('change', $event)"
    )
      template(v-if="!!label" v-slot:label)
        span.pt-0 {{ label }}
</template>

<script>

import { useModelAutoBinding } from '@/helpers/misc/binding';

export default {
  name: 'PhoCheckbox',
  props: {
    value: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    color: {
      type: String,
    },
    disabled: {
      type: Boolean,
      value: false,
    },
    dataTestId: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const { lazyValue } = useModelAutoBinding(emit, props);

    return {
      lazyValue,
    };
  },
};

</script>
